export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  // LOCAL PATCH (lubb): the Nova tab — a chat with Nova on the hub about this
  // conversation, over the Lubb Force channel (LubbForce::Chat).
  LUBB_FORCE: 'LUBB_FORCE',
  // LOCAL PATCH (lubb): forward the conversation's latest email (email inboxes only).
  FORWARD: 'FORWARD',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
